import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// DynamicLink.js
const DynamicLink = (props)=>{
    const { href, children, ...rest } = props;
    // Attempt to dynamically import the Next.js Link component
    const [LinkComponent, setLinkComponent] = React.useState(null);
    React.useEffect(()=>{
        let isMounted = true;
        // Dynamically import the Next.js Link component if Next.js is detected
        // apparently have to cast this to update to "moduleResolution": "NodeNext"
        import("next/link").then((NextLink)=>{
            if (isMounted) {
                setLinkComponent(()=>NextLink.default);
            }
        }).catch((e)=>{
            // If the import fails, we assume we're not in a Next.js environment
            setLinkComponent(null);
        });
        return ()=>{
            isMounted = false;
        };
    }, []);
    // If LinkComponent is loaded, render it. Otherwise, fall back to a regular <a> tag.
    if (LinkComponent) {
        return /*#__PURE__*/ _jsx(LinkComponent, {
            href: href,
            legacyBehavior: true,
            children: /*#__PURE__*/ _jsx("a", {
                ...rest,
                children: children
            })
        });
    } else {
        return /*#__PURE__*/ _jsx("a", {
            href: typeof href === "string" ? href : href.href,
            ...rest,
            children: children
        });
    }
};
export { DynamicLink };
